const project = {
  defaults: {
    project_id: null,
    project_code: null,
    project_name: null,
  },
}

export default project
